'use client'

import { useState } from 'react'
import { TabNavigation } from '../_components/tab-navigation'
import { MyPagePagination } from '../_components/pagination'
import { useMyPageTabs } from '../_hooks/tab-navigation/useMyPageTabs'
import { Order, useMyOrdersQuery } from '@/api/index'
import { OrderList, SpOrderList } from './components/order-list'
import { Button } from '@/components/ui/button'
import Link from 'next/link'

export default function Orders() {
  const [currentPage, setCurrentPage] = useState(1)
  const { tabs, activeTab, subTabs, activeSubTab } = useMyPageTabs()
  const {
    data: { myOrders: { orders = [], pagination = undefined } = {} } = {},
  } = useMyOrdersQuery({
    variables: {
      page: currentPage,
      perPage: 9,
      brandId: process.env.NEXT_PUBLIC_BRAND_ID_CANADAGOOSE || '',
    },
    fetchPolicy: 'cache-and-network',
  })

  if (!pagination) return null

  return (
    <div>
      <div className="mb-[18px] md:mb-10 mt-12 md:mt-20">
        <h1 className="text-2xl md:text-[32px] font-heading text-center tracking-wide">
          マイページ
        </h1>
      </div>
      <div className="mb-32">
        <div className="mb-4 md:mb-16">
          <TabNavigation
            tabs={tabs}
            activeTab={activeTab}
            subTabs={subTabs}
            activeSubTab={activeSubTab}
          />
        </div>
        {orders.length > 0 ? (
          <>
            <div className="md:hidden">
              <SpOrderList orders={orders as Order[]} />
            </div>
            <div className="hidden md:block mb-14">
              <OrderList orders={orders as Order[]} />
            </div>
            <MyPagePagination
              currentPage={pagination.currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={pagination.totalPages}
            />
          </>
        ) : (
          <div className="text-center px-4 mt-10 md:mt-0">
            <p className="text-sm mb-6">ご注文履歴がないようです。</p>
            <Link href="/listings">
              <Button className="rounded-none h-14 px-28 text-sm">
                商品を注文する
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
